import {baseRequest} from "./base";

/**
 * @desc 获取oss token
 */
function getOssStsToken(id){
  return baseRequest(`/api/pcWeb/aliyun/getOssStsToken`,'get');
}
// 删除单个文件
function delFile(params){
  return baseRequest(`/api/pcWeb/aliyun/delFile`,'post',params);
}
// // 批量删除文件
// function delFile(params){
//   return baseRequest(`/api/pcWeb/aliyun/delMultipleFile`,'post',params);
// }



export default {
  getOssStsToken: getOssStsToken,
  delFile,
}
